import { useState } from "react";

const galleryItems = [
  {
    id: 1,
    img: "https://public.readdy.ai/ai/img_res/32ffaa321ddd438b3a50729c92b7f507.jpg",
    title: "Warzone - Solo Victory",
    tag: "Warzone",
    likes: 842,
  },
  {
    id: 2,
    img: "https://readdy.ai/api/search-image?query=tactical%20fps%20game%20screenshot%20dark%20industrial%20warehouse%20military%20operator%20night%20vision%20green%20tint%20stealth%20gameplay%20atmospheric%20dramatic%20shadow%20cinematic&width=500&height=600&seq=gal-2&orientation=portrait",
    title: "Tarkov - Factory Raid",
    tag: "Tarkov",
    likes: 1204,
  },
  {
    id: 3,
    img: "https://readdy.ai/api/search-image?query=battle%20royale%20game%20screenshot%20urban%20combat%20zone%20night%20dramatic%20city%20lights%20rooftop%20sniper%20position%20tactical%20military%20operator%20cinematic%20gameplay&width=700&height=470&seq=gal-3&orientation=landscape",
    title: "PUBG - Squad Wipe",
    tag: "PUBG",
    likes: 677,
  },
  {
    id: 4,
    img: "https://readdy.ai/api/search-image?query=rainbow%20six%20siege%20game%20screenshot%20tactical%20breach%20interior%20destroyed%20room%20operator%20cqb%20combat%20dramatic%20light%20rays%20dust%20particles%20cinematic&width=700&height=470&seq=gal-4&orientation=landscape",
    title: "Siege - Ace Round",
    tag: "R6 Siege",
    likes: 956,
  },
  {
    id: 5,
    img: "https://readdy.ai/api/search-image?query=dark%20military%20shooter%20game%20screenshot%20night%20vision%20mode%20green%20tint%20urban%20street%20patrol%20tactical%20operator%20sniper%20dramatic%20shadows%20cinematic%20gameplay&width=500&height=600&seq=gal-5&orientation=portrait",
    title: "Tarkov - Night Ops",
    tag: "Tarkov",
    likes: 1520,
  },
  {
    id: 6,
    img: "https://readdy.ai/api/search-image?query=modern%20military%20shooter%20gameplay%20screenshot%20helicopter%20extraction%20urban%20rooftop%20dramatic%20sunrise%20fire%20smoke%20explosions%20tactical%20operators%20cinematic%20game%20art&width=700&height=470&seq=gal-6&orientation=landscape",
    title: "Warzone - Helo Extract",
    tag: "Warzone",
    likes: 2310,
  },
];

const tags = ["All", "Warzone", "Tarkov", "R6 Siege", "PUBG"];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const [liked, setLiked] = useState<Set<number>>(new Set());
  const [lightbox, setLightbox] = useState<number | null>(null);

  const filtered = filter === "All" ? galleryItems : galleryItems.filter((g) => g.tag === filter);

  const toggleLike = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setLiked((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <section id="gallery" className="relative py-28 bg-urban-surface">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="flex items-center gap-4">
            <div className="w-1 h-12 bg-red-600" />
            <div>
              <p className="font-rajdhani text-red-500 uppercase tracking-widest text-sm font-semibold">Screenshots & Clips</p>
              <h2 className="font-bebas text-5xl md:text-6xl text-white tracking-wider">Gallery</h2>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {tags.map((t) => (
              <button
                key={t}
                onClick={() => setFilter(t)}
                className={`font-rajdhani font-semibold text-xs uppercase tracking-widest px-4 py-2 rounded-sm transition-all cursor-pointer whitespace-nowrap border ${
                  filter === t
                    ? "bg-red-700 border-red-600 text-white"
                    : "bg-urban-card border-urban-border text-gray-400 hover:border-red-800/50 hover:text-gray-200"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          {filtered.map((item, idx) => {
            const isWide = idx % 5 === 0 || idx % 5 === 3;
            return (
              <div
                key={item.id}
                onClick={() => setLightbox(item.id)}
                className={`relative overflow-hidden rounded-sm cursor-pointer group ${isWide ? "col-span-12 md:col-span-7" : "col-span-12 md:col-span-5"}`}
                style={{ height: "280px" }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />

                <div className="absolute top-3 left-3">
                  <span className="bg-red-700/90 text-white font-rajdhani font-bold text-xs uppercase tracking-widest px-2.5 py-1 rounded-sm">
                    {item.tag}
                  </span>
                </div>

                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                  <p className="font-rajdhani font-bold text-white text-sm">{item.title}</p>
                  <button
                    onClick={(e) => toggleLike(item.id, e)}
                    className={`flex items-center gap-1.5 text-sm font-rajdhani font-semibold px-3 py-1.5 rounded-sm bg-black/50 backdrop-blur-sm transition-all cursor-pointer ${
                      liked.has(item.id) ? "text-red-500" : "text-white hover:text-red-400"
                    }`}
                  >
                    <i className={liked.has(item.id) ? "ri-heart-fill" : "ri-heart-line"} />
                    <span>{item.likes + (liked.has(item.id) ? 1 : 0)}</span>
                  </button>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full border border-white/30 text-white text-xl">
                    <i className="ri-zoom-in-line" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-8"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white text-2xl cursor-pointer"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line" />
          </button>
          {galleryItems.find((g) => g.id === lightbox) && (
            <div className="max-w-4xl max-h-[80vh] overflow-hidden rounded-sm">
              <img
                src={galleryItems.find((g) => g.id === lightbox)!.img}
                alt=""
                className="w-full h-full object-contain"
                onClick={(e) => e.stopPropagation()}
              />
              <div className="bg-urban-card px-6 py-4 flex items-center justify-between">
                <div>
                  <p className="font-bebas text-white text-xl tracking-wider">
                    {galleryItems.find((g) => g.id === lightbox)!.title}
                  </p>
                  <p className="font-rajdhani text-gray-500 text-xs uppercase tracking-widest">
                    {galleryItems.find((g) => g.id === lightbox)!.tag}
                  </p>
                </div>
                <span className="font-rajdhani text-gray-400 text-sm">
                  <i className="ri-heart-line mr-1 text-red-500" />
                  {galleryItems.find((g) => g.id === lightbox)!.likes} likes
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
}
